module.exports = __webpack_public_path__ + "img/logo.a5218b83.png";